var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtarctionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 12V42C37.5 42.4125 37.1625 42.75 36.75 42.75H11.25C10.8375 42.75 10.5 42.4125 10.5 42V6C10.5 5.5875 10.8375 5.25 11.25 5.25H30C30.1875 5.25 30.36 5.3175 30.495 5.4375L37.245 11.4375C37.41 11.58 37.5 11.7825 37.5 12Z",
    fill: "#B9EDF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 12V12.75H30.15C29.655 12.75 29.25 12.3375 29.25 11.835V5.25H30C30.1875 5.25 30.36 5.3175 30.495 5.4375L37.245 11.4375C37.41 11.58 37.5 11.7825 37.5 12Z",
    fill: "#5BC4ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.25H6.75V2.25C6.75 1.8375 7.0875 1.5 7.5 1.5H16.5V3H8.25V11.25Z",
    fill: "#003366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 46.5H7.5C7.0875 46.5 6.75 46.1625 6.75 45.75V36.75H8.25V45H16.5V46.5Z",
    fill: "#003366"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 11.25H39.75V3H31.5V1.5H40.5C40.9125 1.5 41.25 1.8375 41.25 2.25V11.25Z",
    fill: "#003366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 46.5H31.5V45H39.75V36.75H41.25V45.75C41.25 46.1625 40.9125 46.5 40.5 46.5Z",
    fill: "#003366"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 23.25H46.5V24.75H1.5V23.25Z",
    fill: "#003366"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15H15C14.5858 15 14.25 15.3358 14.25 15.75V20.25C14.25 20.6642 14.5858 21 15 21H33C33.4142 21 33.75 20.6642 33.75 20.25V15.75C33.75 15.3358 33.4142 15 33 15Z",
    fill: "#84CF96"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 11.25H18C17.5858 11.25 17.25 11.5858 17.25 12C17.25 12.4142 17.5858 12.75 18 12.75H26.25C26.6642 12.75 27 12.4142 27 12C27 11.5858 26.6642 11.25 26.25 11.25Z",
    fill: "#FFAD60"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 26.25H27C26.5858 26.25 26.25 26.5858 26.25 27C26.25 27.4142 26.5858 27.75 27 27.75H33.75C34.1642 27.75 34.5 27.4142 34.5 27C34.5 26.5858 34.1642 26.25 33.75 26.25Z",
    fill: "#FC9D9A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 29.25H14.25C13.8358 29.25 13.5 29.5858 13.5 30C13.5 30.4142 13.8358 30.75 14.25 30.75H30.75C31.1642 30.75 31.5 30.4142 31.5 30C31.5 29.5858 31.1642 29.25 30.75 29.25Z",
    fill: "#FC9D9A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32.25H16.5C16.0858 32.25 15.75 32.5858 15.75 33C15.75 33.4142 16.0858 33.75 16.5 33.75H28.5C28.9142 33.75 29.25 33.4142 29.25 33C29.25 32.5858 28.9142 32.25 28.5 32.25Z",
    fill: "#FC9D9A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 36.75H20.25C19.8358 36.75 19.5 37.0858 19.5 37.5C19.5 37.9142 19.8358 38.25 20.25 38.25H32.25C32.6642 38.25 33 37.9142 33 37.5C33 37.0858 32.6642 36.75 32.25 36.75Z",
    fill: "#FC9D9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtarctionIcon);
export default __webpack_public_path__ + "static/media/extarctionIcon.c226b7949f5f2e76b888cc4f1a421cf4.svg";
export { ForwardRef as ReactComponent };